import { BsFacebook, BsInstagram } from "react-icons/bs";

const Footer = () => {
  return (
    <div className="h-full w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 items-center justify-items-center bg-black py-4">
        {/* social column */}
        <div className="items-center">
          <div className="text-center">
            <h3>Let's be friends</h3>
          </div>
          <div className="flex">
            <div>
              <a
                href="https://www.facebook.com/profile.php?id=100054614102774"
                target="blank"
              >
                <BsFacebook className="m-4 text-4xl bg-[#FF0080] rounded-full p-1" />
              </a>
            </div>
            <div>
              <a href="https://www.instagram.com/canteabianca/" target="blank">
                <BsInstagram className="m-4 text-4xl bg-[#FF0080] rounded-full p-1" />
              </a>
            </div>
          </div>
        </div>
        {/* Phone number column */}
        <div className="self-start justify-center text-center">
          <div>
            <h3>Give me a call on:</h3>
          </div>
          <div className="inline">
            <a href="tel:01234555666" className="inline text-lg tracking-wide">
              01234 555 666
            </a>
          </div>
        </div>
      </div>
      <div className="text-sm text-center grid grid-cols-1 sm:grid-cols-2 bg-black border-t-[1px] border-white py-2">
        <div>
        <p className="">
          &copy;{new Date().getFullYear()} StefDev. All Rights reserved
        </p>
        </div>
        <div>
        <a
          target="_blank"
          href="https://icons8.com/icon/YdyMJvQ3b9Wj/eyelashes-2d"
        >
          Eyelashes 2D
        </a>{" "}
        icon by{" "}
        <a target="_blank" href="https://icons8.com">
          Icons8
        </a>
        </div>
      </div>
    </div>
  );
};

export default Footer;
